import { ReactNode } from 'react';
import classNames from 'classnames';

type CardColorScheme = 'default' | 'white' | 'ppf';
type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface CardProps {
    children: ReactNode;
    colorScheme?: CardColorScheme;
    header?: ReactNode;
    headingLevel?: HeadingLevel;
    isChildrenWithPadding?: boolean;
    id?: string;
    onClick?: () => void;
}

export const Card = ({ children, header, headingLevel = 'h2', id, colorScheme = 'default', isChildrenWithPadding, onClick }: CardProps) => {
    const HeadingTag = headingLevel;
    const isInteractive = !!onClick;
    
    // Use button for interactive cards to ensure keyboard accessibility
    const WrapperElement = isInteractive ? 'button' : 'div';
    
    return (
        <WrapperElement
            id={id}
            type={isInteractive ? 'button' : undefined}
            className={classNames('flex overflow-hidden flex-col w-full h-full bg-[#edf2f7] rounded-xl shadow-lg', {
                'cursor-pointer': isInteractive,
                'text-left': isInteractive,
            })}
            onClick={onClick}
            tabIndex={isInteractive ? 0 : undefined}
            role={isInteractive && WrapperElement === 'div' ? 'button' : undefined}>
            {header && (
                <HeadingTag
                    className={classNames(
                        'p-4 text-2xl font-semibold',
                        colorScheme === 'default' && 'bg-[#edf2f7] text-[#002c5a]',
                        colorScheme === 'white' && 'bg-white text-[#002c5a]',
                        colorScheme === 'ppf' && 'bg-[#002c5a] text-white'
                    )}>
                    {header}
                </HeadingTag>
            )}
            <div
                className={classNames('flex overflow-hidden flex-col w-full h-full bg-white', colorScheme === 'ppf' && 'bg-[#002c5a]', {
                    'px-4 pb-4': isChildrenWithPadding,
                })}>
                {children}
            </div>
        </WrapperElement>
    );
};
